import { Injectable, NgModule } from '@angular/core';
import { AppService } from 'common-cloudstudio'
import { CloudStudio as ApolusServiceProxy } from '../../../../../../../../CustomerProxies/Apolus/service-proxies/CloudStudio.Apolus.Services.ApolusServiceProxy';
import { ApolusTypes } from '../../../../../../../../CustomerProxies/Apolus/service-proxies/CloudStudio.Core.Gear.Apolus.Types';
export { ApolusTypes };  

export const APOLUS_SERVICE = '/services/Apolus/ApolusService.svc';

@Injectable({
    providedIn: 'root'
})

export class ApolusProxyService {
    private _apolusServiceProxy: ApolusServiceProxy.Apolus.Services.Proxies.ApolusServiceProxy;

    constructor(private _appService: AppService) {
        this._appService.onBaseUrlSet.subscribe(() => {
            this._apolusServiceProxy = null;
        });
    }

    get ApolusService() {
        if (this._apolusServiceProxy) {
            return this._apolusServiceProxy;
        }
        this._apolusServiceProxy = new ApolusServiceProxy.Apolus.Services.Proxies.ApolusServiceProxy(this._appService.getFullURL(APOLUS_SERVICE));
        return this._apolusServiceProxy;
    }

}